<div class="ct-overlay">
  <div class="ct-modal">
    <div class="ct-mdl-body">
      <img class="sm-country-logo" [src]="countryLogo" alt="" />
      <img class="cm-icon" *ngIf="isShowLogo" src="assets/icons/success-tick.svg" alt="" />
      <p class="cm-msg-one" *ngIf="isShowLogo">{{ "OrderSuccessfull" | translate }}</p>
      <p class="cm-msg-two" *ngIf="isShowLogo">
        {{ "ThankyouMessage" | translate }}
      </p>
      <div *ngIf="isRatingVisible">
        <p class="srv-msg1">{{ filteredSurveyData?.popup_text }}</p>
        <div class="hzvt-item-center" *ngIf="filteredSurveyData?.survey_type == 'rating'">
          <img
            *ngFor="let star of stars; let i = index"
            class="srv-star-icon"
            [src]="
              star.isDark
                ? 'assets/icons/srv-star-dark.svg'
                : 'assets/icons/srv-star-light.svg'
            "
            (click)="toggleStar(i)"
            alt=""
          />
        </div>
        <div class="srv-radio-btn-grp" *ngIf="filteredSurveyData?.survey_type == 'question'">
          <div class="row-align-center srv-radio-btn">
            <input
              type="radio"
              id="yesRadio"
              value="Yes"
              [(ngModel)]="selectedOption"
              (change)="onSelectionChange()"
            />
            <label for="yesRadio" class="srv-radio-label">{{ "Yes" | translate }}</label>
          </div>
          <div class="row-align-center srv-radio-btn">
            <input
              type="radio"
              id="noRadio"
              value="No"
              [(ngModel)]="selectedOption"
              (change)="onSelectionChange()"
            />
            <label for="noRadio" class="srv-radio-label">{{ "No" | translate }}</label>
          </div>
        </div>
        <p class="srv-form-label">{{ "CommentOptional" | translate }}</p>
        <textarea
          class="srv-textarea"
          placeholder="{{ 'ShareFeedback' | translate }}"
          [(ngModel)]="feedback"
          (ngModelChange)="onValueChange($event)"
        ></textarea>
      </div>
      <div *ngIf="isfeedback">
        <div class="hzvt-item-center">
          <img src="assets/images/srv-tick.png" alt="survey" />
        </div>
        <p class="srv-msg1">
          {{ "ThankYouForYourValuableFeedback" | translate }}
        </p>
        <p class="srv-msg2">
          {{
            "YourReviewWillHelpUsImproveOurProductAndMakeItUserFriendlyForMoreUsers"
              | translate
          }}
        </p>
      </div>
      <div class="cm-btn-grp" *ngIf="showButtonSurvey">
        <button (click)="onCancel()" class="cm-btn-light">
          {{ "Skip" | translate }}
        </button>
        <button
        [ngClass]="selectedStarCount > 0 || selectedOption != '' ?  'cm-btn-dark' : 'cm-btn-dark-disable'"
        [disabled]="selectedStarCount == 0 && selectedOption == ''"
        (click)="selectedStarCount > 0 || selectedOption != '' ? onSubmit() : null">
          {{ "Next" | translate }}
        </button>
      </div>
      <div class="cm-btn-grp" *ngIf="showButtonTrack">
        <button (click)="onClickCloseModal()" class="cm-btn-light">
          {{ "TrackOrder" | translate }}
        </button>
        <button (click)="onClickNewOrder()" class="cm-btn-dark">
          {{ "NewOrder" | translate }}
        </button>
      </div>
      <div class="hzvt-item-center ty-pc-btn" *ngIf="authData?.userDetails?.menus?.digital_ordering?.sub_menus?.product_portfolio 
    && 
    !authData?.userDetails?.menus?.digital_ordering?.sub_menus?.product_portfolio?.is_disabled"
    (click)="naviagateToProductCatalogue()" 
    (keypress)="naviagateToProductCatalogue()">
      <img src="assets/icons/product-catalogue-filled.svg" alt="pcimg" />
      <p class="pc-txt">{{ "ProductCatalogue" | translate }}</p>
    </div>
    </div>
  </div>
</div>
<div *ngIf="spinnerLoader" class="ct-overlay">
  <app-spinner></app-spinner>
</div>
